import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Textarea } from '../../components/ui/Textarea';
import { Label } from '../../components/ui/Label';
import { RadioGroup, RadioGroupItem } from '../../components/ui/RadioGroup';
export function PodcastCollectionNew() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [source, setSource] = useState('rss');
  return <div className="space-y-6 max-w-2xl" data-id="element-372">
      <div data-id="element-373">
        <Button variant="ghost" size="sm" className="-ml-3 mb-2 text-muted-foreground" onClick={() => navigate('/podcast/collections')} data-id="element-374">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-375" />
          Back
        </Button>
        <h1 className="text-3xl font-bold tracking-tight" data-id="element-376">Create collection</h1>
      </div>

      <Card data-id="element-377">
        <CardContent className="p-6 space-y-6" data-id="element-378">
          <div className="space-y-2" data-id="element-379">
            <Label htmlFor="name" data-id="element-380">Name</Label>
            <Input id="name" placeholder="e.g. Emergency Medicine Picks" value={name} onChange={e => setName(e.target.value)} data-id="element-381" />
          </div>

          <div className="space-y-2" data-id="element-382">
            <Label htmlFor="description" data-id="element-383">Description</Label>
            <Textarea id="description" placeholder="What is this collection about?" className="resize-none h-24" data-id="element-384" />
          </div>

          <div className="space-y-3" data-id="element-385">
            <Label data-id="element-386">Source</Label>
            <RadioGroup defaultValue="rss" value={source} onValueChange={setSource} className="space-y-3" data-id="element-387">
              <div className="space-y-2" data-id="element-388">
                <div className="flex items-center space-x-2" data-id="element-389">
                  <RadioGroupItem value="rss" id="rss" data-id="element-390" />
                  <Label htmlFor="rss" className="font-normal" data-id="element-391">
                    RSS feed (auto-sync)
                  </Label>
                </div>
                {source === 'rss' && <div className="ml-6 border bg-muted/30 p-4 mt-2 space-y-3 rounded-md" data-id="element-392">
                    <Input placeholder="https://feeds.example.com/podcast.xml" data-id="element-393" />
                    <Button variant="ghost" size="sm" data-id="element-394">
                      Validate feed
                    </Button>
                    <p className="text-xs text-muted-foreground" data-id="element-395">
                      New episodes from this feed will appear automatically.
                    </p>
                  </div>}
              </div>

              <div className="space-y-2" data-id="element-396">
                <div className="flex items-center space-x-2" data-id="element-397">
                  <RadioGroupItem value="manual" id="manual" data-id="element-398" />
                  <Label htmlFor="manual" className="font-normal" data-id="element-399">
                    Manual (add episodes one at a time)
                  </Label>
                </div>
                {source === 'manual' && <p className="text-xs text-muted-foreground mt-2 ml-6" data-id="element-400">
                    Add episodes individually after creating the collection.
                  </p>}
              </div>
            </RadioGroup>
          </div>

          <div className="flex justify-end gap-3 pt-4" data-id="element-401">
            <Button variant="outline" onClick={() => navigate('/podcast/collections')} data-id="element-402">
              Cancel
            </Button>
            <Button disabled={!name.trim()} data-id="element-403">Create collection</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}